import loadImage from 'blueimp-load-image';
import { useState } from 'react';

type Props = {
  width?: number;
  height?: number;
  aspectRatio?: number;
};
export const useBase64FromImageFileInput = ({ width = 500, height = 500, aspectRatio = 1 }: Props) => {
  const [base64Content, setBase64Content] = useState<string>();

  const toBase64FromFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.files && e.currentTarget.files[0]) {
      const file = e.currentTarget.files[0];

      loadImage(
        file,
        (canvas) => {
          const scaled = loadImage.scale(canvas as HTMLCanvasElement, {
            minWidth: width,
            minHeight: height,
            maxWidth: width,
            maxHeight: height,
          });

          const c = document.createElement('canvas');
          c.width = scaled.width;
          c.height = scaled.height;
          const ctx = c.getContext('2d');
          ctx!.drawImage(scaled, 0, 0);
          setBase64Content(c.toDataURL('images/png'));
        },
        {
          maxWidth: width,
          maxHeight: height,
          aspectRatio: aspectRatio,
          canvas: true,
        }
      );
    }
  };

  return { toBase64FromFile, base64Content };
};
